import { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import WorkOrderAmendmentPreviewDialog from './WorkOrderAmendmentPreviewDialog';
import WorkOrderAmendmentsTable from './WorkOrderAmendmentsTable';
import { sortWorkOrderAmendmentsDesc } from '#/modules/momMgmt/workOrder/helper/amendmentStatus';

const WorkOrderAmendmentsPanel = ({ detail, onRefetch }) => {
  const [previewAmendmentId, setPreviewAmendmentId] = useState(null);

  const rows = useMemo(
    () => sortWorkOrderAmendmentsDesc(detail?.amendments),
    [detail?.amendments],
  );

  // 只存 id，預覽內容永遠取最新 detail（版本衝突 refetch 後 updatedAt 才會更新）
  const previewAmendment = useMemo(
    () => rows.find((row) => row?.id === previewAmendmentId) ?? null,
    [rows, previewAmendmentId],
  );

  return (
    <>
      <WorkOrderAmendmentsTable
        rows={rows}
        onPreview={(row) => setPreviewAmendmentId(row?.id ?? null)}
      />
      <WorkOrderAmendmentPreviewDialog
        open={Boolean(previewAmendment)}
        onOpenChange={(open) => {
          if (!open) {
            setPreviewAmendmentId(null);
          }
        }}
        amendment={previewAmendment}
        workOrderId={detail?.id}
        workOrderStatus={detail?.status}
        onMutated={onRefetch}
      />
    </>
  );
};

WorkOrderAmendmentsPanel.propTypes = {
  detail: PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
    amendments: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  onRefetch: PropTypes.func,
};

export default WorkOrderAmendmentsPanel;
